var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.09 53.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0b65ff;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "instaRecurso 43") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.06,16.85a1.86,1.86,0,0,1-1.92,1.82,1.83,1.83,0,0,1-1.94-1.93,1.85,1.85,0,0,1,2-1.91A2,2,0,0,1,37.06,16.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.54,52.73A26.12,26.12,0,1,1,52.59,26.62,26.1,26.1,0,0,1,26.54,52.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.54,1A25.62,25.62,0,1,1,1,26.62,25.59,25.59,0,0,1,26.54,1m0-1A26.62,26.62,0,1,0,53.09,26.62,26.61,26.61,0,0,0,26.54,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.84,18.82c-.29-4.46-2.49-6.64-6.94-6.78C30.6,12,28.31,12,26,12v0c-2.38,0-4.75-.07-7.13,0-3.88.13-6.23,2.4-6.56,6.26a103,103,0,0,0,0,15.51,5.8,5.8,0,0,0,5.42,5.73,90,90,0,0,0,16.08.07c3.72-.3,5.62-2.33,6-6A94.71,94.71,0,0,0,39.84,18.82ZM25.93,34.65a8.31,8.31,0,0,1-8.52-8.83,8.5,8.5,0,0,1,8.78-8.65,8.46,8.46,0,0,1,8.51,8.65A8.61,8.61,0,0,1,25.93,34.65Zm9.21-16a1.83,1.83,0,0,1-1.94-1.93,1.85,1.85,0,0,1,2-1.91,2,2,0,0,1,1.9,2A1.86,1.86,0,0,1,35.14,18.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.19,17.17a8.5,8.5,0,0,0-8.78,8.65,8.31,8.31,0,0,0,8.52,8.83,8.61,8.61,0,0,0,8.77-8.83A8.46,8.46,0,0,0,26.19,17.17ZM26,31.5a5.63,5.63,0,1,1,5.71-5.7A5.59,5.59,0,0,1,26,31.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.68,25.8a5.62,5.62,0,1,1-5.59-5.55A5.57,5.57,0,0,1,31.68,25.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramBlue);
export default __webpack_public_path__ + "static/media/instagram-blue.638c4dada9567975d65b978cb8e01630.svg";
export { ForwardRef as ReactComponent };